// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1HFI3","detailsBorder":"styles_detailsBorder__3T8en"};